(function (window, document) {
    if (document.querySelector('.news-ticker-slider') !== null
        && document.querySelector('.neos-backend') == null) {
        $('.news-ticker-slider .news-ticker-slider-items').slick({
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToShow: 3,
            prevArrow: $('.news-ticker-prev'),
            nextArrow: $('.news-ticker-next'),
            centerMode: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
})(window, document);
